import React from "react";

function Download(props) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M9.113 3.84c.541 0 1.061.214 1.449.602L12 5.88h8.16c1.122 0 2.04.918 2.04 2.04v10.2c0 1.122-.918 2.04-2.04 2.04H3.84a2.046 2.046 0 01-2.04-2.04l.01-12.24c0-1.122.908-2.04 2.03-2.04h5.273zm7.375 5.61h-4.08v4.08h-3.06l4.743 4.743c.204.204.52.204.724 0l4.733-4.743h-3.06V9.45z"
        fillRule="nonzero"
      />
    </svg>
  );
}

export default Download;
